module.exports = __webpack_public_path__ + "static/media/helping-others-large@2x.7dcc81b4.png";